module.exports = __webpack_public_path__ + "059fe2c2b3b8c0f4d2e00e9930a62cad.svg";